import { RequestPaymentParameters } from '../../types';
import generatePaymentRequestForm from '../../utilities/generatePaymentRequestForm';
import getSession from '../../utilities/getSession';
import withAuthenticationHeaders from '../../utilities/withAuthenticationHeaders';
import { getApiClient } from '../index';

type CreatePaymentRequestParams = {
  requestOptions: RequestPaymentParameters;
  paymentMethodData?: io.flow.v0.unions.PaymentMethodData;
};

export default function createPaymentRequest(
  params: CreatePaymentRequestParams,
): Promise<io.flow.v0.models.PaymentRequest> {
  const { organization, sessionId } = params.requestOptions.config;
  return getSession({
    organization,
    sessionId,
  }).then((session) => getApiClient().paymentRequest.post({
    organization,
    headers: withAuthenticationHeaders(session.id),
    body: generatePaymentRequestForm(
      params.requestOptions,
      {
        paymentMethodData: params.paymentMethodData,
      },
    ),
  })).then((response) => {
    if (response.ok) {
      return response.body;
    }

    throw new Error(`createPaymentRequest: Failed to create PR, status: ${response.status}`);
  });
}
